/* ========================================================================
   Comparison table
 ========================================================================== */

app.comparisonTable = (function () {
  'use strict';

  function init() {
    const tables = document.querySelectorAll('[data-comparison-table]');
    if (tables.length === 0) return;

    tables.forEach((table) => {
      const modalButtons = table.querySelectorAll('[data-target]');

      modalButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          var modalEl = document.querySelector('[data-modal-id="' + button.dataset.target + '"]');
          if (modalEl) {
            const heading = modalEl.querySelector('[data-modal-heading]');
            const body = modalEl.querySelector('[data-modal-body]');

            Dialog({
              type: 'message',
              title: heading.innerHTML,
              messageHtml: body.innerHTML,
              confirm: modalEl.dataset.buttonText,
              // closable: true,
              clickedElement: button,
            });
          }
        });
      });
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
